import React from "react";
import ContactList from "./contact-list.jsx";

export default class TagMessage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      focusId: 0
    }
    this.handleSelectTag = this.handleSelectTag.bind(this);
    this.moveAction = this.moveAction.bind(this);
    this.getFocusId = this.getFocusId.bind(this);
  }

  handleSelectTag(memberId) {
    this.props.addTag(memberId)
    this.props.onClose()
  }

  componentDidMount() {
    document.addEventListener('keyup', this.moveAction);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.moveAction);
  }

  moveAction(e) {
    e.preventDefault()

    if (e.keyCode === 38 || e.key === 'ArrowUp') {
      this.setState((preState) => {
        const focusId = preState.focusId;
        return {
          focusId: (focusId === 0) ? (this.props.groupMembers.length - 1) : (focusId - 1)
        }
      });
    }

    if (e.keyCode === 40 || e.key === 'ArrowDown') {
      this.setState((preState) => {
        const focusId = preState.focusId;
        return {
          focusId: (focusId === (this.props.groupMembers.length - 1)) ? 0 : (focusId + 1)
        }
      });
    }

    if (e.keyCode === 13 || e.key === 'Enter') {
      this.handleSelectTag(this.props.groupMembers[this.state.focusId].user);
    }
  }

  getFocusId() {
    try {
      let focusId = this.state.focusId;
      const topic = this.props.groupMembers[focusId];
      if (topic === undefined) {
        focusId = 0
        this.setState({
          focusId: 0
        });
      }
      return this.props.groupMembers[focusId].user
    } catch (error) {

    }
  }

  render() {
    return (
      <div id="tag-message">
        <ContactList
          tinode={this.props.tinode}
          contacts={this.props.groupMembers}
          myUserId={this.props.myUserId}
          showOnline={false}
          showUnread={false}
          showContextMenu={false}
          showAcs={false}
          small={true}
          onTopicSelected={this.handleSelectTag}
          focusTag={true}
          focusId={this.getFocusId()}
        />
      </div>
    );
  }
}
